<template>
  <div class="w-full bg-image p-5">
    <div class="mb-4 mr-28">
      <h1>Posez quelques questions à votre patient</h1>
      <p>{{ step.description }}</p>
    </div>
    <PathwayInlineSurvey v-if="isInline" :step="step" :consumer-key="consumerKey" :pathway="pathway" />
    <PathwayModalSurvey v-else :step="step" :consumer-key="consumerKey" :pathway="pathway" />
    <PathwayStepInsert v-if="active" :step="step" />
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import PathwayStepInsert from '@/pathway/components/PathwayStepInsert.vue';
import {Pathway, PathwayStep} from "@/program/interfaces/Program";
import PathwayInlineSurvey from "@/pathway/components/PathwayInlineSurvey.vue";
import PathwayModalSurvey from "@/pathway/components/PathwayModalSurvey.vue";

const props = defineProps<{
    pathway: Pathway;
    step: PathwayStep;
    consumerKey: string;
    active: boolean;
}>();

/**
 * Check if the survey should be launched in full screen modal mode.
 */
const isInline = computed(() => {
    return props.step.type !== 'survey-bundle';
});

</script>

<style scoped>
.bg-image {
    background-image: url('@/assets/images/pharmacist-bubble.png');
    background-repeat: no-repeat;
    background-position: top 20px right 20px;
    background-color: rgba(255,255,255,0.4);
    background-size: 15%;
    background-blend-mode: lighten;
}
</style>
